module.exports = __webpack_public_path__ + "img/map_locname.82a6ada3.png";